import { INavSearchUxXP } from "@faire/web-api/indigofair/seo/INavSearchUxXP";
import { NAV_SEARCH_UX_240826 } from "@faire/web-api/indigofair/settings/NAV_SEARCH_UX_240826";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

/**
 * `isTreatment` represents the base behaviour of the XP: a search bar which hides when scrolling down.
 * `isStickyVariant` and `isBannerlessVariant` are extensions of the base behaviour, with
 * `isStickyVariant` disabling the hiding of the search bar and `isBannerlessVariant` removing the banner + adding a new placeholder copy.
 */
export const useSettingNavSearchUX = (): {
  isTreatment: boolean;
  isStickyVariant: boolean;
  isBannerlessVariant: boolean;
} => {
  const setting = useSetting(
    NAV_SEARCH_UX_240826,
    INavSearchUxXP.Bucket.BUCKET_UNKNOWN
  );
  return {
    isTreatment:
      setting !== INavSearchUxXP.Bucket.CONTROL &&
      setting !== INavSearchUxXP.Bucket.BUCKET_UNKNOWN,
    isStickyVariant: setting === INavSearchUxXP.Bucket.VARIANT_B,
    isBannerlessVariant: setting === INavSearchUxXP.Bucket.VARIANT_C,
  };
};

export const useAssignSettingNavSearchUX = () =>
  useAssignSetting(NAV_SEARCH_UX_240826);
